import * as React from 'react';

export interface WithClassnameProps {
  className: string;
}

/**
 * Very basic HOC
 *
 * For more information, visit: https://dev.to/danhomola/react-higher-order-components-in-typescript-made-simple
 */
const WithClassname = ({ className }: WithClassnameProps) => <TOriginalProps extends {}>(
  BaseComponent: React.SFC<TOriginalProps>
) => (props: TOriginalProps) =>
  className ? (
    <div className={className}>
      <BaseComponent {...props} />
    </div>
  ) : (
    <div>
      <BaseComponent {...props} />
    </div>
  );

export default WithClassname;



// WEBPACK FOOTER //
// ./src/components/hoc/withClassname/WithClassname.tsx